import React from "react";

import colorSet from "@/src/styles/color";
import { Button, ConfigProvider, type ButtonProps } from "antd";
import styled from "styled-components";

interface Props extends ButtonProps {}

const SelectOptionButton: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', Arial, sans-serif",
          borderRadiusLG: 0,
          fontSizeLG: 16,
          paddingContentHorizontal: 16,
          paddingContentVertical: 8,
        },
      }}
    >
      <StyledButton type="text" size="large" {...rest}>
        {children}
      </StyledButton>
    </ConfigProvider>
  );
};

const StyledButton = styled(Button)`
  width: 100%;
  text-align: left;

  &:hover {
    &&& {
      background-color: ${colorSet.gray10};
    }
  }
`;

export default SelectOptionButton;
